<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import { FORM_TEMPLATES } from '../templates';

const emit = defineEmits(['select']);
const { t } = useI18n();

const dialogRef = ref(null);

const open = () => dialogRef.value?.open();
const close = () => dialogRef.value?.close();

const choose = templateId => {
  emit('select', templateId);
  close();
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    width="3xl"
    :title="t('FORMS_MGMT.TEMPLATES.TITLE')"
    :description="t('FORMS_MGMT.TEMPLATES.DESCRIPTION')"
    :show-cancel-button="false"
    :show-confirm-button="false"
  >
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <button
        type="button"
        class="relative p-5 rounded-xl border-2 border-dashed border-n-weak hover:border-n-slate-7 bg-n-solid-1 transition-colors text-left cursor-pointer"
        @click="choose(null)"
      >
        <div
          class="w-11 h-11 rounded-xl bg-n-alpha-2 flex items-center justify-center mb-4"
        >
          <span class="i-lucide-plus w-5 h-5 text-n-slate-11" />
        </div>
        <h4 class="text-base font-semibold text-n-slate-12 mb-1">
          {{ t('FORMS_MGMT.TEMPLATES.BLANK.NAME') }}
        </h4>
        <p class="text-sm text-n-slate-11">
          {{ t('FORMS_MGMT.TEMPLATES.BLANK.DESCRIPTION') }}
        </p>
      </button>

      <button
        v-for="template in FORM_TEMPLATES"
        :key="template.id"
        type="button"
        class="relative p-5 rounded-xl border-2 border-n-weak hover:border-n-slate-7 bg-n-solid-1 transition-colors text-left cursor-pointer"
        @click="choose(template.id)"
      >
        <div
          class="w-11 h-11 rounded-xl flex items-center justify-center mb-4"
          :style="{ backgroundColor: `${template.color}1F` }"
        >
          <span
            class="w-5 h-5"
            :class="template.icon"
            :style="{ color: template.color }"
          />
        </div>
        <h4 class="text-base font-semibold text-n-slate-12 mb-1">
          {{ template.name }}
        </h4>
        <p class="text-sm text-n-slate-11 line-clamp-2">
          {{ template.description }}
        </p>
        <div class="mt-3 flex items-center gap-1.5 text-xs text-n-slate-10">
          <span class="i-lucide-list-checks w-3.5 h-3.5" />
          {{
            t('FORMS_MGMT.TEMPLATES.FIELD_COUNT', {
              count: template.fields.length,
            })
          }}
        </div>
      </button>
    </div>
  </Dialog>
</template>
